import {gql} from "@irati/utils/gql"

const validateChangeEmailMutation = gql`
  mutation ValidateChangeEmail($emailInput: ValidateChangeEmailInput!) {
    validateChangeEmail(emailInput: $emailInput)
  }
`

export {validateChangeEmailMutation}
